export default "__VITE_ASSET__DCt8q2r1__"